import { render, staticRenderFns } from "./homeDashboardUserStatistics.vue?vue&type=template&id=68b4df84&scoped=true"
import script from "./homeDashboardUserStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardUserStatistics.vue?vue&type=style&index=0&id=68b4df84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b4df84",
  null
  
)

export default component.exports